// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';

import { Grid } from '../../../lib/base';
import { Link } from '../../../lib/link';

interface Props {
  icon: React.ReactElement;
  link: string;
  title: string;
}

export const SocialLink = ({ icon, title, link }: Props) => (
  <Grid container flexWrap="nowrap" spacing={0}>
    <Grid size={{ xs: 'auto' }}>{icon}</Grid>
    <Grid size={{ xs: 'auto' }}>
      <Link newTab path={link} title={title} white absolute />
    </Grid>
  </Grid>
);
